import { useQuery } from "@tanstack/react-query";
import { api } from "./api";

export function useSettings() {
  const { data } = useQuery({
    queryKey: ["settings"],
    queryFn: async () => (await api.get("/settings")).data,
    staleTime: 5 * 60 * 1000,
  });
  return data || {
    whatsapp_number: "390555277501",
    phone: "055 5277501",
    email: "info@edilstudiofi.it",
    address: "Via Salvador Allende 14/c, 50018 Scandicci (FI)",
    company_name: "Edilstudio Immobiliare",
  };
}

export const whatsappLink = (number, text) =>
  `https://wa.me/${(number || "").replace(/[^0-9]/g, "")}?text=${encodeURIComponent(text || "Salve, vorrei maggiori informazioni.")}`;
